import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
    FETCH_ALL_USER,
    UPDATE_USER,
    CREATE_USER, 
    DELETE_USER,
    VERIFY_EMAIL,
    SET_PASSWORD,
    FORGOT_PASSWORD,
} from 'constants/users.constants'
import {
    fetchUsersSuccess,
    updateUserSuccess,
    createUserSuccess,
    deleteUserSuccess,
    verifyEmailSuccess,
    setUserPasswordSuccess,
} from "actions/users.action";
import { showErrors, stopLoader } from "actions/general.action";
import { authinstance, authInstanceWithoutHeaders } from "sagas";
import qs from 'qs'


// user sagas

const fetchUsersRequest = async (page) => {
    return authinstance.get('api/v1/super_admin/users/index?page=1&roles=1,2,3,4');
}

function* fetchUsers({ payload }) {
    try {
        const reuslt = yield call(fetchUsersRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(fetchUsersSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const updateUsersRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.is_portal = 1

    return authinstance({
        method: 'put',
        url: 'api/v1/super_admin/users/' + payload.id,
        data: qs.stringify(o)
    })
}

function* updateUser({ payload }) {
    try {
        const reuslt = yield call(updateUsersRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(updateUserSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const createUsersRequest = async (payload) => {
    let o = Object.assign({}, payload);
    o.is_portal = 1
    o.call_back_url = process.env.REACT_APP_FRONT_END_HOST + '/setpassword'

    return authinstance({
        method: 'post',
        url: 'api/v1/super_admin/users',
        data: qs.stringify(o)
    })
}

function* createUser({ payload }) {
    try {
        const reuslt = yield call(createUsersRequest, payload);
        if (reuslt.message) {
            yield put(showErrors(reuslt.message));
        } else {
            yield all([
                put(createUserSuccess(reuslt.data)),
                //put(stopLoader("User created"))
            ])
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const deleteUsersRequest = async (id) => {

    return authinstance({
        method: "delete",
        url: '/api/v1/super_admin/users/' + id,
        headers: {
          'Content-Type': 'text/plain'
        },
        data: "",
    });
}

function* deleteUser({ payload }) {
    try {
        const reuslt = yield call(deleteUsersRequest, payload);
        if (!reuslt.status) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(deleteUserSuccess(reuslt.data));
            yield put(stopLoader())
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const verifyEmailWithTokenRequest = async (token) => {
    let fd = new FormData();
    fd.append('token', decodeURIComponent(token));

    return authInstanceWithoutHeaders.post("api/v1/public/users/validate_email", fd);
}

function* verifyEmailWithToken({ payload }) {
    
    try {
        const reuslt = yield call(verifyEmailWithTokenRequest, payload);
        if (reuslt.status !== 200) {
            yield put(showErrors(reuslt.data.message));
        } else {
            yield put(verifyEmailSuccess());
        }
    } catch (error) {
        if (error.response.data.status === 406) {
            yield put(showErrors(error.response.data.message));
        } else {
            yield put(showErrors(error.message));
        }
    }
}

const setPasswordWithTokenRequest = async ({ password, token }) => {
    let fd = new FormData();
    fd.append('token', decodeURIComponent(token));
    fd.append('password', password);
    fd.append('type', 'set_password');

    return authInstanceWithoutHeaders.post("api/v1/public/users/update_password", fd);
}

function* setPasswordWithToken({ payload }) {
    
    try {
        const reuslt = yield call(setPasswordWithTokenRequest, payload);
        if (reuslt.status === 403) {
            yield put(showErrors(reuslt.message));
        } else {
            yield put(setUserPasswordSuccess());
            yield put(stopLoader(reuslt.message));
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

const forgotPasswordWithEmailRequest = async (email) => {
    let fd = new FormData();
    fd.append('email', email);
    fd.append('call_back_url', process.env.REACT_APP_FRONT_END_HOST + '/set_password');

    return authInstanceWithoutHeaders.post("api/v1/public/users/forgot_password", fd);
}

function* forgotPasswordWithEmail({ payload }) {
    
    try {
        const reuslt = yield call(forgotPasswordWithEmailRequest, payload);
        if (reuslt.status === 200) {
            yield put(stopLoader(reuslt.data.message));
        } else {
            yield put(showErrors(reuslt.data.message));
        }
    } catch (error) {
        yield put(showErrors(error.message));
    }
}

// fork user
export function* forkFetchUsers() {
    yield takeEvery(FETCH_ALL_USER, fetchUsers);
}

export function* forkUpdateUser() {
    yield takeEvery(UPDATE_USER, updateUser);
}

export function* forkCreateUser() {
    yield takeEvery(CREATE_USER, createUser);
}

export function* forkDeleteUser() {
    yield takeEvery(DELETE_USER, deleteUser);
}

export function* verifyEmail() {
    yield takeEvery(VERIFY_EMAIL, verifyEmailWithToken);
}

export function* setPassword() {
    yield takeEvery(SET_PASSWORD, setPasswordWithToken);
}

export function* forgotPassword() {
    yield takeEvery(FORGOT_PASSWORD, forgotPasswordWithEmail);
}

export default function* rootSaga() {
    yield all([
        fork(forkFetchUsers),
        fork(forkUpdateUser),
        fork(forkCreateUser),
        fork(forkDeleteUser),
        fork(verifyEmail),
        fork(setPassword),
        fork(forgotPassword),
    ]);
}